import { client } from "../../lib/api.ts";

/** URL length ceiling — very long prompts get truncated in the deep link. */
const MAX_QUERY_CHARS = 6000;

const TARGETS = [
  { key: "claude", label: "Claude", url: (q: string) => `https://claude.ai/new?q=${q}` },
  { key: "chatgpt", label: "ChatGPT", url: (q: string) => `https://chatgpt.com/?q=${q}` },
] as const;

/**
 * One-click "open this prompt in an LLM chat" links, next to the copy button.
 * Fires the fire-and-forget `launched` metric per click.
 */
export function LaunchInLlm({ promptId, body }: { promptId: string; body: string }) {
  const q = encodeURIComponent(body.slice(0, MAX_QUERY_CHARS));

  const record = () => {
    void client.metrics.recordPromptLaunched(promptId).catch(() => {});
  };

  return (
    <span className="llm-launch">
      {TARGETS.map((t) => (
        <a
          key={t.key}
          className="llm-launch-btn"
          href={t.url(q)}
          target="_blank"
          rel="noopener noreferrer"
          onClick={record}
        >
          {t.label} ↗
        </a>
      ))}
    </span>
  );
}
